import { createContext, useContext, useState, useMemo } from "react";

const StateContext = createContext();

export const StepFormContextProvider = ({ children }) => {
    const [userId, setUserId] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [formId, setFormId] = useState('');

    const contextValue = useMemo(() => ({
        userId, setUserId,
        isLoading, setIsLoading,
        formId, setFormId,
    }), [userId, isLoading, formId]);

    return (
        <StateContext.Provider value={contextValue}>
            {children}
        </StateContext.Provider>
    );
}

export const useStateContext = () => useContext(StateContext);